// Post visibility: the scopes a post can be given, widest first, and the
// icon for each. 'local' is public, but only on this server.

export const SCOPES = ['public', 'unlisted', 'local', 'private', 'direct']

const ICONS = {
  public: 'globe',
  unlisted: 'lock-open',
  private: 'lock',
  direct: 'envelope',
  local: 'igloo',
}

// the scopes a repeat of a post can be given: never wider than the post
// (the server refuses that), never direct
const REPEAT_SCOPES = {
  public: ['public', 'unlisted', 'local', 'private'],
  unlisted: ['public', 'unlisted', 'local', 'private'],
  local: ['local', 'private'],
  private: ['private'],
}
export const repeatScopes = (visibility) => REPEAT_SCOPES[visibility] ?? []

export const visibilityIcon = (visibility) => ICONS[visibility] ?? ICONS.public
